var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.$emit("close")
        },
      },
    },
    [
      _c("div", { staticClass: "modal-content" }, [
        _c("h3", [_vm._v("Практическая часть обучения")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Уважаемый слушатель Вы успешно завершили теоретическую часть обучения."
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      Следующий этап - практическая часть, которую Вы проходите ОЧНО с преподавателем!\n      Следуйте указаниям ответственного за обучения Вашей организации и Куратора от\n      АНО ДПО «ПРАВО», которые направят Вас на прохождение практической части обучения.\n      Скачайте предоставленный здесь Лист практических занятий и предоставьте ее преподавателю.\n      По завершению практической части и получении отметки о её прохождении, поставьте\n      в Лист практических занятий дату и подпись.\n    "
          ),
        ]),
        _vm._v(" "),
        _vm.practiceSheetUrl
          ? _c(
              "a",
              {
                staticClass: "btn btn-secondary btn-modal",
                attrs: { href: _vm.practiceSheetUrl, target: "_blank" },
              },
              [_vm._v("\n      Скачать Лист практических занятий\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-secondary btn-modal",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          },
          [_vm._v("Понятно")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }